import React, { Component } from 'react';
import './adminhome.css';

export class AdminHome extends Component {
    static displayName = AdminHome.name;

    constructor(props) {
        super(props);
        this.state = {
            
        };
    }

    render() {
        return (
            <div>
                <h1 style={{ textAlign: 'center' }}>Welcome to TracSoft CMS!</h1>
                <h2 style={{ textAlign: 'center' }}>This is your website management system.</h2>
            </div>
        );
    }
}
